import React, { useEffect, useRef } from 'react';
import img1 from '../assets/_DSC2548.jpg'
import img2 from '../assets/WhatsApp_Image_2022-.jpeg'
import img3 from '../assets/_DSC2211.jpg'
import img4 from '../assets/WhatsApp_Image_2022- (1).jpeg'

const Second = () => {
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => entries.forEach(e => {
                if (e.isIntersecting) e.target.classList.add('visible');
            }),
            { threshold: 0.15 }
        );
        const els = ref.current?.querySelectorAll('.reveal');
        els?.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    const tags = ['Local culture', 'Authenticity', 'Adventure', 'Connection'];

    return (
        <div ref={ref} className="bg-dark-2 py-24 md:py-36 overflow-hidden">
            <div className="container">
                <div className="flex flex-col md:flex-row gap-16 items-center">
                    {/* Text */}
                    <div className="reveal w-full md:w-1/2 flex flex-col gap-6">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-px bg-it-green opacity-90" />
                            <p className="font-unbounded text-it-green text-xs uppercase tracking-widest">
                                Our philosophy
                            </p>
                        </div>
                        <h2 className="font-unbounded font-bold text-3xl sm:text-4xl md:text-5xl text-white leading-tight">
                            What we uphold<br />
                            <span className="text-it-green">in our tours</span>
                        </h2>
                        <p className="font-manrope text-white/60 text-base md:text-lg leading-relaxed">
                            During our trips it is essential to connect with the local people.
                            This interaction will allow you to discover customs and traditions,
                            blending cultures and experiences in ways you never imagined.
                        </p>
                        <div className="flex flex-wrap gap-2 mt-2">
                            {tags.map(tag => (
                                <span key={tag} className="tag-pill">{tag}</span>
                            ))}
                        </div>
                    </div>

                    {/* Images Grid */}
                    <div className="reveal w-full md:w-1/2 grid grid-cols-2 gap-4" style={{ transitionDelay: '0.15s' }}>
                        {[
                            { src: img1, mt: '' },
                            { src: img2, mt: 'mt-8' },
                            { src: img3, mt: '-mt-4' },
                            { src: img4, mt: 'mt-4' },
                        ].map(({ src, mt }, i) => (
                            <div key={i} className={`${mt} rounded-3xl overflow-hidden group`}>
                                <img
                                    src={src}
                                    className="w-full h-48 md:h-56 object-cover transition-transform duration-700 group-hover:scale-110"
                                    alt={`Tour ${i + 1}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Second;
